<template>
  <TableLayout :permissions="['business:productlabel:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="品牌名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入品牌名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
<!--      <el-form-item label="所属板块" prop="module">
        <el-select
          v-model="searchForm.module"
          placeholder="请选择所属板块"
        >
          <el-option
            :key="0"
            :value="0"
            label="平台商城"
          ></el-option>
          <el-option
            :key="1"
            :value="1"
            label="咖豆商城"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:productlabel:create', 'business:productlabel:delete']">
        <li><el-button type="primary" @click="$refs.operaProductLabelWindow.open('新建商品标签信息表')" icon="el-icon-plus" v-permissions="['business:productlabel:create']">新建</el-button></li>
        <li><el-button type="danger" @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:productlabel:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="module" label="所属板块" min-width="100px">
          <template slot-scope="{row}">
            {{ row.module==0?'平台商城':'咖豆商城' }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="品牌名称" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码(升序)" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
                v-model="row.status"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions(['business:productlabel:update', 'business:productlabel:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaProductLabelWindow.open('编辑商品标签信息表', row)" icon="el-icon-edit" v-permissions="['business:productlabel:update']">编辑</el-button>
            <el-button type="text" style="color: red;"  @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:productlabel:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaGoodsBrandWindow ref="operaProductLabelWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaGoodsBrandWindow from '@/components/business/OperaGoodsBrandWindow'
import {updateStatusById} from "@/api/business/labels";
export default {
  name: 'ProductLabel',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaGoodsBrandWindow },
  data () {
    return {
      // 搜索
      searchForm: {

        name: '',
        module: '',
        type: 1
      }
    }
  },
  created () {
    this.config({
      module: '商品标签信息表',
      api: '/business/labels',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    statusChange (row) {
      this.api.updateStatusById({ id: row.id, status: row.status })
        .then(() => {
          this.$message.success('操作成功')
        })
        .catch(e => {
          this.$message.error('操作成功')
        })
        .then(() => {
          this.handlePageChange()
        })
    }
  }
}
</script>
